import { NgModule }            from '@angular/core';
import { RouterModule }        from '@angular/router';
import { CanActivateViaOAuthGuard } from '../oAuth.canActivateGuard';

import { HomeComponent } from '../peiluyots/home/home.component';
import { LoginComponent } from '../login/login.component';
import { EndRishumComponent } from '../peiluyots/endRishum/end-rishum.component'
import { ReportComponent } from '../reports/peilut-reports/report.component'
import { EndTkufatRishumComponent } from "./end-tkufat-rishum/end-tkufat-rishum.component";
import { PeilutComponent } from "./peilut.component";

@NgModule({
  imports: [RouterModule.forChild([
  {
    path: 'peiluyots', component: HomeComponent, canActivate: [CanActivateViaOAuthGuard], children: [
      { path: 'endrishum', component: EndRishumComponent },
      { path: 'rishum-expired', component: EndTkufatRishumComponent },
      { path: 'reports', component: ReportComponent },
      { path: '', redirectTo: 'rishum', pathMatch: 'full' },
      { path: 'rishum', component: PeilutComponent }
    ]
  }
  ])],
  exports: [RouterModule]
})
export class PeiluyotRouting {}